import api from '../components/axiosConfig';

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Sesión expirada o inválida
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const authService = {
  // Login de usuario
  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });

      // El backend establece la cookie automáticamente
      // Capturar la respuesta del login que incluye requiere_cambio_password
      const loginData = response.data;
      
      // Perfil completo (incluye requiere_cambio_password); el login también lo envía
      const user = await authService.getCurrentUser();
      const requiereCambio =
        typeof loginData.requiere_cambio_password === 'boolean'
          ? loginData.requiere_cambio_password
          : (user.requiereCambioPassword ?? false);
      const userMerged = { ...user, requiereCambioPassword: requiereCambio };
      localStorage.setItem('user', JSON.stringify(userMerged));

      return {
        user: userMerged,
        requiere_cambio_password: requiereCambio,
      };
    } catch (error) {
      console.error('Error en login:', error);
      throw error;
    }
  },

  // Registro de usuario
  register: async (userData) => {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      console.error('Error en registro:', error);
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      console.error('Error en recuperación de contraseña:', error);
      throw error;
    }
  },

  // Obtener usuario actual
  getCurrentUser: async () => {
    try {
      const response = await api.get('/auth/me');
      const userData = response.data;
      
      // TRANSFORMACIÓN: Mapear campos del backend al frontend
      const user = {
        ...userData,
        rol: userData.role,  // Crear campo "rol" a partir de "role"
        requiereCambioPassword: userData.requiere_cambio_password || false
      };
      
      // Guardar usuario transformado en localStorage para acceso rápido
      localStorage.setItem('user', JSON.stringify(user));
      
      return user;
    } catch (error) {
      console.error('Error al obtener usuario:', error);
      throw error;
    }
  },

  // Logout
  logout: async () => {
    try {
      // Llamar al endpoint de logout para invalidar la cookie
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Error en logout:', error);
    } finally {
      // Limpiar datos locales
      localStorage.removeItem('user');
    }
  },

  // Verificar si está autenticado
  isAuthenticated: () => {
    // Con cookies, verificamos si hay usuario en localStorage
    // El backend validará la cookie en cada request
    return !!localStorage.getItem('user');
  },

  // Obtener usuario guardado
  getStoredUser: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    const userData = JSON.parse(userStr);
    
    // TRANSFORMACIÓN: Asegurar que los campos transformados existen
    if (userData.role && !userData.rol) {
      userData.rol = userData.role;
    }
    if (userData.requiere_cambio_password !== undefined && userData.requiereCambioPassword === undefined) {
      userData.requiereCambioPassword = userData.requiere_cambio_password;
    }
    
    return userData;
  },
};

export default authService;
